import { NativeBaseProvider, Text, Box, Center, Heading } from "native-base";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useState, useEffect } from "react";
import React from "react";


export default function Dashboard({ navigation }){
    const [DataUser, setDataUser] = React.useState({
        data_user:[
            name => '',
            email => ''
        ]
    });
    console.log(DataUser)
    const getData = async () => {
        try {
          const jsonValue = await AsyncStorage.getItem("@data_user");
          setDataUser(JSON.parse(jsonValue));
        } catch (e) {
          console.log(e);
        }
      };
      useEffect(() => {
        getData();
      }, []);
    
    return(
        <NativeBaseProvider>
           <Box w={'100%'} h={'100%'} bg={'white'} >
            <Center>
            <Box w={'80%'} maxW={400} h={100} bg={'light.50'} p={4} top={10}>
            <Heading fontSize={'xl'}>Name: <Text>{DataUser.data_user.name}</Text></Heading>
            <Heading fontSize={'xl'}>Email: <Text>{DataUser.data_user.email}</Text></Heading>

            </Box>
            </Center>
           </Box>
        </NativeBaseProvider>
    );
}